import register from '../register';

register( 'star-animation', function() {

  let container = document.querySelector('.star-logo-container');
  let logo = document.querySelector('.star-logo');
  let stars = document.querySelector('.star-background');
  let offset = 600;
  let doc = document.documentElement;

  let logoOffset = getTopOffset( container );

  function getTopOffset( el ) {
    let top = 0;
    let node = el;

    while ( node ) {
      top += node.offsetTop;
      node = node.offsetParent;
    }

    return top;
  }

  function getScrollTop() {
    return ( window.pageYOffset || doc.scrollTop ) - ( doc.clientTop || 0 );
  }

  function checkScroll() {
    let ticking = true;
    let scrollTop = getScrollTop();

    if ( scrollTop >= logoOffset - offset ) {
      logo.classList.add('start');
      stars.classList.add('start');
      ticking = false;
    }

    if ( ticking ) {
      window.requestAnimationFrame( checkScroll );
    }
  }

  checkScroll();

});

export default undefined;
